import FeaturedDestinationCarousel from "./FeaturedDestinationCarousel";

const featuredItems = [
  { src: "/images/featured-city-life.jpg", alt: "Friends walking through a busy Lagos street" },
  { src: "/images/featured-culture.jpg", alt: "Dancers and a drummer at a waterfront cultural market" },
  { src: "/images/featured-food.jpg", alt: "Jollof rice, suya, fish and plantain spread" },
  { src: "/images/featured-nightlife.jpg", alt: "Rooftop lounge overlooking Lagos at night" },
];

function FeaturedDestination() {
  return (
    <FeaturedDestinationCarousel
      title="Featured Destinations"
      subtitle="Explore Top Cities with Local Experts."
      items={featuredItems}
    />
  );
}

export default FeaturedDestination;
